import ForgotPassword, { ForgotPasswordProps } from './ForgotPassword';
import withInteractor from './ForgotPassword.interactor';
import withPresenter from './ForgotPassword.presenter';

export type { ForgotPasswordProps };
export default withInteractor(withPresenter(ForgotPassword));
